import record from "../record/modules/record";

export default {
  record,
}



// WEBPACK FOOTER //
// ./src/store/record/index.js